import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { ME_CUSTOMER_QUERY } from './portal.gql';

/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */

function Row({ label, value }: { label: string; value: string | null }): JSX.Element | null {
  if (!value) return null;
  return (
    <div className="flex items-center justify-between gap-2 border-b py-2 text-sm last:border-0">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}

export function PortalProfilePage(): JSX.Element {
  const { t } = useTranslation();
  const { data } = useQuery(ME_CUSTOMER_QUERY, { fetchPolicy: 'cache-and-network' });
  const me = data?.meCustomer;

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-semibold">{t('portal.nav_profile')}</h2>
      <div className="bg-background rounded-xl border px-3">
        <Row label={t('portal.full_name')} value={me?.full_name ?? null} />
        <Row label={t('portal.phone')} value={me?.phone ?? null} />
        <Row label={t('portal.email')} value={me?.email ?? null} />
      </div>
    </div>
  );
}
